import type { Statement } from "@xapi/xapi";
import { getExerciseId } from "../../../../utils/statements/statement-parse";

export const filterUniqueItemId = (statements: Statement[]): Statement[] => {
  const unique: Statement[] = [];
  statements.forEach((statement) => {
    if (unique.some((stmt) => getExerciseId(statement) === getExerciseId(stmt)))
      return;
    unique.push(statement);
  });
  return unique;
};

/** Keeps the most recent statement of each item, as a new answer supersedes. */
export const latestByItemId = (statements: Statement[]): Statement[] => {
  const latest = new Map<string | undefined, Statement>();
  statements.forEach((statement) => {
    const itemId = getExerciseId(statement);
    const current = latest.get(itemId);
    if (!current || (statement.timestamp ?? "") > (current.timestamp ?? ""))
      latest.set(itemId, statement);
  });
  return [...latest.values()];
};
